/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tasks/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CoreEmbeddableSection from 'DesignSystem/CoreEmbeddableSection/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'



/** @type {import('Simple/types.js').View} */
export default function Tasks({
  children,
  viewPath = "/App/Account/Content/Tasks"
  
}) {
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let tabCoreParamsValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'coreParams',
})
let globalRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'refresh_embedded_section',
})
let globalSessionExpiredRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'session_expired_refresh_embedded_section',
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 marginTop={0}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
 overflowX="hidden"
 overflowY="hidden"
>
{childProps => (
<CoreEmbeddableSection
{...childProps}
  viewPath={`${viewPath}/CoreEmbeddableSection`}
 section_type="tasks"
 data="global.current_location._id"
 location_id={globalCurrentLocationIdValueData}
 data="tab.coreParams"
 params={tabCoreParamsValueData}
 data="global.refresh_embedded_section"
 refresh={globalRefreshEmbeddedSectionValueData}
 data="global.session_expired_refresh_embedded_section"
 session_expired_refresh={globalSessionExpiredRefreshEmbeddedSectionValueData}
/>
)}
</TysiaCardContent>
)}
</TysiaCard>
{children}
</React.Fragment>)
}